import { Navigate, useLocation } from "react-router-dom";
import { useCustomerSession } from "@/hooks/useCustomerSession";

interface Props {
    children: React.ReactNode;
}

export function RequireCustomerAuth({ children }: Props) {
    const { user, loading } = useCustomerSession();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center text-muted-foreground">
                Checking session…
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/customer/login" replace state={{ from: location }} />;
    }

    return <>{children}</>;
}
